<script setup lang="ts">
import MeetingDateList from "@/domains/home/services/configurations/views/agm/tabs/MeetingDateList.vue";
</script>

<template>
  <div class="flex">
    <div class="w-full bg-white rounded-sm text-gray mx-2 my-3">
      <MeetingDateList />
    </div>
  </div>
</template>
